import axios from "axios";
import config from "../../config";
import { JunkValue, JunkValueRequest, JunkValuesModel } from "./types";

const apiUrl = config.api;

const getJunkValues = async (): Promise<JunkValuesModel> => {
  const response = await axios.get<JunkValuesModel>(`${apiUrl}/junk-values`);

  return response.data;
};

const addJunkValue = async (
  junkValue: JunkValueRequest,
): Promise<JunkValuesModel> => {
  const response = await axios.post<JunkValuesModel>(
    `${apiUrl}/junk-values`,
    junkValue,
  );

  return response.data;
};

const deleteJunkValue = async (value: JunkValue): Promise<void> => {
  const response = await axios.delete(`${apiUrl}/junk-values/${value.id}`);

  return response.data;
};

export { getJunkValues, addJunkValue, deleteJunkValue };
